import React from 'react';
import './css/Boton.css';

class Boton extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  componentDidMount(){}

  render(){
    const {titulo, backgroundColor, onClick, disabled} = this.props;
    return(
      <span
        className="Boton"
        style={{
          backgroundColor:backgroundColor,
          color:disabled ? 'grey' : 'white',
          cursor: disabled ? 'not-allowed' : null
        }}
        onClick={() => disabled ? null : onClick()}
      >
        {titulo}
      </span>
    );
  }
}

export default Boton;

/*
import Boton from '../../Boton';
import Boton from '../Boton';
import Boton from './Boton';
<Boton
  backgroundColor=""
  titulo=""
  onClick={() => onClick()}
/>
*/
